import React, {useEffect} from "react";

import "./CandidateDirectory.scss";
import {useAppDispatch, useAppSelector} from "redux/hooks";

import ListCandidateDirectory from "./Tab/ListCandidateDirectory";
import {setSiderKey} from "redux/reducer/common";

const CandidateDirectory: React.FC = () => {
  document.title = "Danh mục ứng viên";
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setSiderKey("ungVien"));
  }, []);

  return (
    <div className=" candidate-directory page">
      <div className="main">
        <ListCandidateDirectory />
      </div>
    </div>
  );
};
export default CandidateDirectory;
